import {useAuth} from "react-oidc-context";
import {useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import {
    CANVAS_ID,
    MIN_DESCRIPTION_LENGTH,
    DESCRIPTION_PLACEHOLDER,
} from "../../constants";
import {Endpoint, handleResponse, sendRequest} from "../../utils/api";
import {
    Button,
    ContentLayout,
    Form,
    FormField,
    Grid,
    Header,
    SpaceBetween,
    Textarea
} from "@cloudscape-design/components";
import {useArchitectureDataStore} from "../../data_store/architectureDataStore.ts";
import {ArchitectureUtils} from "../../utils/architecture";
import {ArchitectureGenerationErrorFlashbar} from "../canvas/architecture";

export const NewArchitecture = () => {
    const auth = useAuth()
    const navigate = useNavigate()

    const architecture = useArchitectureDataStore((state) => state.getById(CANVAS_ID));
    const [description, setDescription] = useState(architecture?.description ?? '')
    const [isGenerating, setIsGenerating] = useState(ArchitectureUtils.isGeneratingArchitecture(architecture));

    const descriptionInvalid = description.length < MIN_DESCRIPTION_LENGTH && description.length !== 0
    const generateButtonTitle = isGenerating? 'Generating architecture' : 'Generate architecture'

    useEffect(() => {
        setIsGenerating(ArchitectureUtils.isGeneratingArchitecture(architecture))

        if (ArchitectureUtils.hasBuiltDependencyGraph(architecture)) {
            navigate('/architectures/' + CANVAS_ID, {replace: true})
        }
    }, [architecture?.architectureState])

    useEffect(() => {
        setDescription(architecture?.description ?? '')
    }, [architecture?.description])

    function generateArchitecture() {
        setIsGenerating(true)

        const params = {
            architectureDescription: description,
            interactionFlowSteps: 10
        }

        sendRequest(Endpoint.generateArchitecture(auth.user.id_token, params))
            .then(handleResponse)
            .catch(() => setIsGenerating(false))
    }

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "80vh",
            }}
        >
            <ContentLayout>
                    <form onSubmit={(event) => {event.preventDefault()}}>
                        <Grid
                            gridDefinition={[
                                { colspan: { default: 0, xxs: 1 } },
                                { colspan: { default: 12, xxs: 10 } },
                                { colspan: { default: 0, xxs: 1 } },
                            ]}
                        >
                            <div></div>

                            <SpaceBetween direction={'vertical'} size={'l'}>
                                {architecture?.architectureError != null &&
                                    <ArchitectureGenerationErrorFlashbar message={architecture?.architectureError} />
                                }

                                <Form
                                    actions={
                                        <SpaceBetween direction={'horizontal'} size={'s'}>
                                            <Button iconName={'gen-ai'} variant={'primary'} loading={isGenerating} disabled={descriptionInvalid || description.length === 0} onClick={generateArchitecture}>{generateButtonTitle}</Button>
                                        </SpaceBetween>
                                    }
                                    header={
                                        <Header variant={'h2'}>{`Hello ${auth.user.profile.email.split("@")[0]}, what do you want to build today?`}</Header>
                                    }
                                >
                                    <FormField
                                        stretch={true}
                                        errorText={descriptionInvalid? `The description must be at least ${MIN_DESCRIPTION_LENGTH} characters long.` : ''}
                                    >
                                        <Textarea
                                            onChange={({detail}) => setDescription(detail.value)}
                                            value={description}
                                            placeholder={DESCRIPTION_PLACEHOLDER}
                                            disabled={isGenerating}
                                            rows={5}
                                        />
                                    </FormField>
                                </Form>
                            </SpaceBetween>

                            <div></div>
                        </Grid>
                    </form>
            </ContentLayout>
        </div>
    )
}